import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@services/platform/platform.service';

@Injectable({ providedIn: 'root' })
export class LoadingService {

    // region Fields

    private loadingController: HTMLIonLoadingElement;

    private isLoading: boolean = false;

    /**
     * Ionic present()/dismiss() is async; overlapping calls (e.g. hide before
     * show finishes) could leave the overlay visible while isLoading is false.
     */
    private indicatorChain: Promise<void> = Promise.resolve();

    get showLoadingIndicator(): boolean {
        return this.isLoading;
    }

    set showLoadingIndicator(value: boolean) {
        if (value !== this.isLoading) {
            this.isLoading = value;
            this.indicatorChain = this.indicatorChain
                .then(() => this.applyIndicatorVisibility(value))
                .catch(() => undefined);
        }
    }

    // endregion

    constructor(
        private loadCtrl: LoadingController,
        private translate: TranslateService,
        private platform: PlatformService
    ) {
    }

    async init() {
        this.loadingController = await this.loadCtrl.create({
            message: this.translate.instant('common_loading'),
            showBackdrop: this.platform.isMobile
        });
    }

    private async applyIndicatorVisibility(show: boolean): Promise<void> {
        if (show) {
            if (this.loadingController == null) {
                await this.init();
            }
            await this.loadingController.present();
            return;
        }
        if (this.loadingController != null) {
            try {
                await this.loadingController.dismiss();
            } catch {
                /* not presented or already dismissed */
            }
            this.loadingController = null;
        }
    }
}
